window.queryData = window.queryData || {};
const stringExists = (str, arr) => {
    for (let substr of arr) {
        if (str.indexOf(substr) !== -1) {
            return true
        }
    }
    return false
}

function isInAppWebView() {
    const userAgent = window.navigator.userAgent;
    const isWUMobileAppWebView = /(wv|WebView)/i.test(userAgent);
    return isWUMobileAppWebView;
}
function isMobileOrInApp() {
    const userAgent = window.navigator.userAgent;
    const isMobileOrApp = isInAppWebView() || /Android|iPhone/i.test(userAgent);
    return isMobileOrApp;
}

function getBrowserName() {
    const userAgent = window.navigator.userAgent || '';
    const brands = window.navigator.userAgentData?.brands || [];
    const brandNames = brands.map((brand) => brand.brand).join(' ');

    if (/Microsoft Edge|Edge|Edg\//i.test(brandNames) || /EdgA\//i.test(userAgent) || /EdgiOS\//i.test(userAgent) || /Edg\//i.test(userAgent)) {
        return 'edge';
    }
    if (/Google Chrome|Chromium/i.test(brandNames) || /Chrome\//i.test(userAgent) || /CriOS\//i.test(userAgent)) {
        return 'chrome';
    }
    if ((/Mozilla\//i.test(userAgent) && /Firefox\//i.test(userAgent)) || /FxiOS\//i.test(userAgent)) {
        return 'firefox';
    }
    if (/Version\/.*Safari\//i.test(userAgent) || /iPhone|iPad|iPod/i.test(userAgent)) {
        return 'safari';
    }
    return 'chrome';
}

window.getBrowserName = getBrowserName;

function getParamFromUrl() {
        let params = window.location.search || window.location.hash //"?FundsOut=BA&FundsIn=POLI";
        if (params === "") {
            params = null;
        }
        return params;
    }

function getURLParameter(name) {
    const urlParams = getParamFromUrl();
    let returnValue = urlParams && decodeURIComponent((new RegExp(`[?|&]` + name + `=` + `([^&;]+?)(&|#|;|$)`).exec(urlParams) || [, ""])[1].replace(/\+/g, `%20`)) || null
    if (returnValue !== undefined && returnValue !== null) {
        returnValue = returnValue.trim();
    }
    return returnValue;
}

function escapeHtmlAttr(value) {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

// function to get the R4 and E1 country
function getR4Country() {
    let r4Countries = (window.pageData && window.pageData.R4_DEPLOYED_COUNTRIES);
    let e1Countries = (window.pageData && (window.pageData.E1_COUNTRIES || window.pageData.E1_COUNTRIES !== undefined));
    r4Countries = JSON.parse(r4Countries) || [];
    e1Countries = JSON.parse(e1Countries) || [];
    const allcountries = [...r4Countries, ...e1Countries];
    return allcountries.indexOf(window.pageData.country.toUpperCase()) !== -1;
}
//

const env = ['origin.cms', 'cloudfront', 'wucom-wdp-dev', 'localhost', 'www2.westernunion.com', 'www3.westernunion.com'];

const prodUrl = `https://www.westernunion.com/`;

function getHostName() {
    const gethostname = window.location.hostname;
    return gethostname;
}

function replaceLinkQueryParams(links, rules) {
    const {country: countryCode, lang: langCode} = getCountryAndLanguage();
    const langPrefix = `/${countryCode}/${langCode}`;

    links.forEach(link => {
      const url = new URL(link.href, window.location.origin);
      const originalPath = url.pathname;

      for (const { match, replaceWith, params } of rules) {
        if (originalPath.includes(match)) {
            if (originalPath.includes('/frequently-asked-questions/')) {
                continue;
            }
          let newPath;

          const hasLangPrefix = originalPath.startsWith(langPrefix);

          if (replaceWith) {
            const base = hasLangPrefix ? langPrefix : '';
            const cleanReplace = replaceWith.startsWith('/') ? replaceWith : `/${replaceWith}`;
            newPath = base + cleanReplace;
          } else {
            newPath = originalPath;
          }

          url.pathname = newPath;

          if (params) {
            Object.entries(params).forEach(([key, value]) => {
              url.searchParams.set(key, value);
            });
          }

          link.href = url.toString();
          break;
        }
      }
    });
}

const sortingFn = (a, b) => {
    const valueA = a.toUpperCase();
    const valueB = b.toUpperCase();
    return (valueA < valueB) ? -1 : (valueA > valueB) ? 1 : 0;
}

const getParams = (sendTo,sendCurrency,sendAmount,paramFundsOut,paramFundsIn,language,sendURL) => {
    let paramString = '';
    const isAmerigo = WuAmerigoConfigs.isAmerigo();
    if (isAmerigo && (sendURL.indexOf('web/send-money/start') == -1)) {
        paramString = `page=/send_money&payment.country_send=${sendTo}&payment.currency_send=${sendCurrency}&payment.amount_get=${sendAmount}&fundsout=${paramFundsOut}&fundsin=${paramFundsIn}`;
    }
    return ( isAmerigo && (sendURL.indexOf('web/send-money/start') == -1)) ? (language === 'en' ? `?~${paramString}` : `?lang=${language}&${paramString}`)
            : `?ReceiveCountry=${sendTo}&ISOCurrency=${sendCurrency}&SendAmount=${sendAmount}&FundsOut=${paramFundsOut}&FundsIn=${paramFundsIn}`;
}

const uaeCheck = `alfardanexchange`;

const uatUrl = `https://wudispatcher-uatrs3.westernunion.com/`;
const russiaUrl = `https://www.westernunion.ru/`;
const www3Url = `https://www3.westernunion.com/`;
const uatCiUrl = `https://wudispatcher-uatci2.westernunion.com/`
const uatRs2Url = `https://wudispatcher-uatrs2.westernunion.com/`
const uatRs3Url = `https://wudispatcher-uatrs3.westernunion.com/`

const getHttpRequestUrl = (host, country, isCurrencyConvertedUpdated) => {
    if(location.href.indexOf('localhost') !== -1) return uatRs2Url
    if(location.href.indexOf('www2') !== -1) return `${location.origin}/`
    if(location.href.indexOf('www3') !== -1) return `${location.origin}/`    
    if(location.href.indexOf('uatci2') !== -1) return uatCiUrl
    if(location.href.indexOf('uatrs2') !== -1) return uatRs2Url
    if(location.href.indexOf('uatrs3') !== -1) return uatRs3Url    
    if(isCurrencyConvertedUpdated) return host;
    const url = stringExists(location.href,
                            ['origin.cms', 'cloudfront', 'wucom-wdp-dev', 'localhost','www3','uatrs3'])
                                    ? uatUrl:
                                        (country === 'ru' ? russiaUrl : (host || prodUrl));
    return url;
}

const toggleClass = (el, classToRemove, classToAdd) => {
    if(!el) return;
    el.classList.remove(classToRemove);
    el.classList.add(classToAdd);
}

const toggleClasses = (el, classOne, classTwo, value) => {
    classOne && el.classList.toggle(classOne, value === null)
    classTwo && el.classList.toggle(classTwo, value !== null)
}

const getExceptionList = () => ['ab','qm', 'qn', 'qo', 'qp','qq', 'qr', 'qs', 'qt', 'qu', 'qv', 'qw', 'qx', 'qy', 'qz',
                'xf', 'xn', 'xp', 'xt', 'xy'
            ];

const partnerIdEnabledCountries = ['CL'];

const getPartnerIdForCountry = {
    'CL' : {
        webPartnerId: "CL959DTWPP1B",
    }
}

const isPartnerIdEnabled = (country) =>{
    return partnerIdEnabledCountries.includes(country);
}

function setCookie(cookieName, cookieValue, exDays, locationPath) {
    const date = new Date();
    date.setTime(date.getTime() + (exDays*24*60*60*1000));
    let expires = "expires="+ date.toUTCString();
    if(!locationPath) {
        document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
    } else {
        document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=" + locationPath;
    }
  }

const routerUrl = location.hostname.startsWith('www') ? `/router/` : `https://digital-chs-uat.digitalprod.awswuintranet.net/router/`

const dealsApiURL = location.hostname.startsWith('www') ? `/content/v2/fuse/deals` : `https://digital-chs-uat-dr.digitalprod.awswuintranet.net/content/v2/fuse/deals`

function generateUniqueID() { // Public Domain/MIT
    var d = new Date().getTime();//Timestamp
    var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16;//random number between 0 and 16
        if(d > 0){//Use timestamp until depleted
            r = (d + r)%16 | 0;
            d = Math.floor(d/16);
        } else {//Use microseconds since page-load if supported
            r = (d2 + r)%16 | 0;
            d2 = Math.floor(d2/16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

function inactivityTime(timeInterval,openPopUp) {
    let IdleTimeOut = timeInterval;
    let idleSecondsTimer;
    let idleSecondsCounter = 0;
    // DOM Events
    if (/complete|interactive|loaded/.test(document.readyState)) {
        resetTimer();
    } else {
        window.addEventListener("load",  resetTimer, true);
    }
    let events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart','click'];
    events.forEach(function (name) {
      document.addEventListener(name, resetTimer, true);
    });
    // Increment the idle time counter every second.
    idleSecondsTimer = window.setInterval(timerIncrement, 1000); // 1 second

    function timerIncrement() {
        idleSecondsCounter++;
        if(idleSecondsCounter >= IdleTimeOut){
            window.clearInterval(idleSecondsTimer);
            openPopUp();
            window.removeEventListener('load', resetTimer, true); // remove event Listerner
            events.forEach(function (name) {
              document.removeEventListener(name, resetTimer, true);  // remove event Listerner
            });
        }
    }
    function resetTimer () {
        idleSecondsCounter = 0;
    }
};

const hideSpinnerMain = (spinnerContainer) => {
    spinnerContainer = spinnerContainer || document.getElementById("spinnerContainer")
    spinnerContainer && toggleClass && toggleClass(spinnerContainer, 'd-flex', 'd-none')
}

const showSpinnerMain = (spinnerContainer) => {
    spinnerContainer = spinnerContainer || document.getElementById("spinnerContainer")
    spinnerContainer && toggleClass && toggleClass(spinnerContainer, 'd-none', 'd-flex')
}

/**
 * capitalizeWords - converts string into capitalize like NEW YORK to New York
 * @param {*} inputString
 * @returns
 */
const capitalizeWords = (inputString) => {
    try {
        if(inputString){
            inputString = inputString.toLowerCase();
            let words = inputString.split(" ");
            let formattedString = words.map((word) => {
                return word[0].toUpperCase() + word.substring(1);
            }).join(" ");
            return formattedString;
        }

    } catch (error) {
        console.log(`Error into capitalized the string`);
        return inputString;
    }
}

const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

const phoneformat = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im

const phoneFormatWithoutPlus = /^[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im


// method to get Country and Language
const getCountryAndLanguage = () => {
    const locationPath = location.pathname.replace('/pages/latest', '').split('/');
    const country = locationPath[1];
    const lang = locationPath[2];
    return {
        country,
        lang
    }
}

const showValidationMessage = (targetElement) => {
    const parent = targetElement.parentNode;
    parent.classList.add("wu-input--error");
    const errorElementDiv = parent.querySelector(".wu-input--error");
    if (errorElementDiv) {
      errorElementDiv.classList.remove("d-none");
    }
  };

const hideValidationMessage = (targetElement) => {
    const parent = targetElement.parentNode;
    parent.classList.remove("wu-input--error");
    const errorElementDiv = parent.querySelector(".wu-input--error");
    if (errorElementDiv) {
      errorElementDiv.classList.add("d-none");
    }
  };

const maskingEmail = (email) => {
    if (email) {
      let emailAdrs = email.split("");
      let finalArr = [];
      let len = emailAdrs.indexOf("@");
      let index = 0;
      for (let char of emailAdrs){
        if(index>1 && index< len -2){
          finalArr.push("*");
        }else { finalArr.push(char);
      } index++;
    }
      return finalArr.join("");
    }
    return "";
  };

   const passwordFormat = /((?=.*[a-z])(?=.*[A-Z])(?=.*[0123456789])^.{8,16}$)/;

  const eyeIconView = (defaultEyeView = true,isV2, eyeIconViewPassword, styleProps) => {
    if (!isV2) return;
    if (defaultEyeView) {
      eyeIconViewPassword.removeAttribute("style");
    }

    else{
        for(const [prop, value] of Object.entries(styleProps)){
            eyeIconViewPassword.style[prop] = value;
        }
    }
  };

  const showHideValidationMessage = (targetElement, typeOfOperation) => {
    const parent = targetElement.parentNode;
    const errorElementDiv = parent.querySelector(".wu-input--error");
    if(typeOfOperation === "show"){
        parent.classList.add("wu-input--error");
        errorElementDiv ? classList.remove("d-none") : null
    }else{
        parent.classList.remove("wu-input--error");
        errorElementDiv ? classList.add("d-none") : null
    }
  }

  const getCurrencyFromPriceCorridor = (selectedCountryIsoCode) => {
    try {
        let currencyWithOrderOne = null
        let selectedCountryObj = countryCurrencyDefaults.countries.find ((country) => country.country.isoCode.toLowerCase() === selectedCountryIsoCode.toLowerCase() ) || null;
        const currencyListOfSelectedCountry = selectedCountryObj?.country?.currencies;
        for (let i = 0; i < currencyListOfSelectedCountry.length; i++) {
          currencyWithOrderOne = currencyListOfSelectedCountry.find(
            (currency) => currency.currency.order === "1"
          );
        }
        if(currencyWithOrderOne?.currency?.isoCode === 'UYU') return 'UYP'
        return currencyWithOrderOne.currency.isoCode
    } catch(e) {
        console.log(`price corridor failed`)
        console.log(e)
    }
}


/* Close QR Code Pop-up*/
(() => {
    const qrCodeModalMain = document.getElementById("qrCodeModalMain");
    if (!qrCodeModalMain) return;
    const keyDownListenerModal = (event) => {
        if (event.key === 'Escape') {
            closeQRCodeModal()
        }
      }
      qrCodeModalMain?.querySelector('.qrCodeClose').addEventListener('click', (event) => {
        closeQRCodeModal();
      });

      window.addEventListener('keydown', keyDownListenerModal)

    const closeQRCodeModal = () => {
        qrCodeModalMain.classList.add('d-none')
        qrCodeModalMain.classList.remove('d-flex')
        CookieService.setCookie("qrCodeClosed", "true");
    }
})();

const getSessionStorageItems = (keys) => keys.map((key) => ({key, value : window.sessionStorage.getItem(key)}))

const setSessionStorageItems = (itemsArr) => itemsArr.forEach(({key, value}) => window.sessionStorage.setItem(key, value))


const CHANGE_COUNTRY_CURRENCY_FOR_API_REQUEST = {
    'BA': [{ 'BAM' : 'BAD' }],
    'RU': [{ 'RUB' : 'RUR' }],
    'UY': [{ 'UYU' : 'UYP' }],
    'VE': [{ 'VEF' : 'VIB' }],
    'ST': [{ 'STD' : 'STN' }]
};

const setCountryCurrencyChange = (countryCode, currencyCode) => {
    let convertedCurrency;
    let convertCountryCurrencyObj = CHANGE_COUNTRY_CURRENCY_FOR_API_REQUEST && CHANGE_COUNTRY_CURRENCY_FOR_API_REQUEST[countryCode] ? CHANGE_COUNTRY_CURRENCY_FOR_API_REQUEST[countryCode] : undefined;    
    if (convertCountryCurrencyObj && convertCountryCurrencyObj.length > 0) {
        convertCountryCurrencyObj.forEach(function(currencyObj) {
            Object.keys(currencyObj).forEach(function (k) {
                if (k === currencyCode) {
                    convertedCurrency = currencyObj[k];
                }
            });
        });
    }
    return convertedCurrency ? convertedCurrency : currencyCode;
}

const showHideJoinCTA = (joinCTAElements, show) => {
    joinCTAElements?.forEach((el) => {
        const privacyLink = el.parentNode?.parentNode?.querySelector('.protection-link-mobile');
        if(show) {
            el.classList.remove("d-none");
            el.classList.add("d-inline-block");
            privacyLink?.classList.remove("mar-xs-tp");
        } else {
            el.nextElementSibling?.classList.add("d-none");
            el.classList.add("d-none");
            el.classList.remove("d-inline-block");
            privacyLink?.classList.add("mar-xs-tp");
        }
    });
}


/* Mobile Sticky*/
(() => {
    const mobileSticky = document.getElementById("mobile-sticky");
    const joinCTAElements = document.querySelectorAll('.receiver_join_now_cta');
    if (!mobileSticky) return;
    
    if (window.matchMedia('only screen and (max-width: 768px)').matches) {
        showHideJoinCTA(joinCTAElements, false);
		document.querySelector('body').insertAdjacentElement('afterend', mobileSticky);
        const innerHeight = window.innerHeight || 800;
        const scrollMobileStickyListener = (e) => {
            if(window.scrollY > innerHeight) {
                showHideJoinCTA(joinCTAElements, false);
                mobileSticky.classList.remove('d-none');
                mobileSticky.classList.add('d-block');
            } else {
                mobileSticky.classList.remove('d-block');
                mobileSticky.classList.add('d-none');
                showHideJoinCTA(joinCTAElements, true);
            }
        }
		window.addEventListener('scroll', scrollMobileStickyListener);
    }
})();

const senderCountryExceptionList = ['US'];

const validateExceptionList = (senderCountryCode,receiverCountryCode) => {
    let enableCountry = senderCountryExceptionList.includes(senderCountryCode.toUpperCase());
    return (enableCountry) ? true : !getExceptionList().includes(receiverCountryCode.toLowerCase());
}

const showHideElements = (el, show) => {
    show ? el.classList.remove("d-none") : el.classList.add("d-none");
};


function isValidPostalCode(postalCode, countryCode) {
  switch (countryCode) {
    case "US":
      postalCodeRegex = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/;
      break;
    case "CA":
      postalCodeRegex = /^([a-zA-Z][0-9][a-zA-Z])\s*([0-9][a-zA-Z][0-9])$/;
      break;
    default:
      postalCodeRegex = /^(?:[A-Z0-9]+([- ]?[A-Z0-9]+)*)?$/;
  }
  return postalCodeRegex.test(postalCode);
}

const randomStringGenerator = (data=0x100) => {
    return Math.floor((1 + Math.random()) * data)
        .toString(16)
        .substring(1);
};

const roundToTwo = (value) => {
  return (Math.round(value * 100) / 100).toFixed(2);
};

const triggerAmplitudePageEvent = (eventName) => {
    if(eventName && window.getAnalyticsData) {
        let pageEvent = 'page_'+eventName
        let pageEventAttr = window.getAnalyticsData();
        pageEventAttr.page_name = eventName;
        if (window.amplitude && window.logEvents) {
            window.logEvents(pageEvent, pageEventAttr);
            sessionStorage.setItem("wuAmplitude_pageName", eventName)
        }
    }
}

const getAkCountryRMO = () => {
  const akCountry = CookieService.getCookie("AKCountry");
  return akCountry?.toLowerCase() === 'ca' ? 'CA' : 'US'
}

const QUICK_LOGIN_VIA_CODE_COUNTRIES = ['US'];

function getCookieValueByKeyName(cookieName) {
    const name = cookieName + '=';
    const cookiesArray = document.cookie.split(';');
    for (let i = 0; i < cookiesArray.length; i++) {
      let cookie = cookiesArray[i];
      while (cookie.charAt(0) == ' ') cookie = cookie.substring(1);
      if (cookie.indexOf(name) === 0) return cookie.substring(name.length, cookie.length);
    }
    return '';
  }

const triggerAmplitudeLogEvent = (eventName, eventProperty) => {
    if (eventName) {
        let eventInfo = { ...getAnalyticsData(), ...eventProperty};
        if (Object.keys(eventInfo).length > 0 && window?.amplitude && window?.logEvents) {
            window.logEvents(eventName, eventInfo);
        }
    }
}

const isNonProdEnv = (hostName) => {
    return env.find(domain => hostName.indexOf(domain) > -1);
}


const isFeatureEnabledViaOptimizelyFeatureExperimentation = (featureKey, customVariation) => {
    if (window && window['optimizelyFeatureExp']) {
        const user = window['optimizelyFeatureExp'];
        if (user) {
            const decision = user.decide(featureKey);
            if (decision && decision.ruleKey) {
                logOptimizelyFeatureExp(decision, customVariation);
                const variation = decision.variationKey?.toUpperCase();
                if (variation === 'ON' || variation === customVariation?.toUpperCase()) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
    } else {
        return sessionStorage.getItem(featureKey) === 'true';
    }
}

const logOptimizelyFeatureExp = (decision, customVariation) => {
    const user = window['optimizelyFeatureExp'];
    const properties = {
        ab_test: decision.ruleKey,
        ab_test_variant: decision.ruleKey + '_' + decision.variationKey
    };
    if (customVariation) {
        properties.ab_test_variant = customVariation;
    }
    const tags = {
        "$opt_event_properties": properties
    };
    user.trackEvent(decision.ruleKey, tags);
    window.logEvergageExperienceAmplitudeEvent(properties);
}

const getVariablesForActiveVariation = (featureKey) => {
    let flags = null;
    if (window && window['optimizelyFeatureExp']) {
        const user = window['optimizelyFeatureExp'];
        if (user) {
            const decision = user.decide(featureKey);
            if (decision && decision.ruleKey && decision.variables) {
                flags = decision.variables;
            }
        }
    }
    return flags;
}

// Function to convert SVG to WebP
 async function convertSvgToWebP(svgUrl) {
    const response = await fetch(svgUrl);
    const svgText = await response.text();

    return new Promise((resolve) => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const img = new Image();
        img.onload = function () {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL("image/webp")); // Convert to WebP format
        };

        img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgText);
    });
}

// sessionParam only session storage key value which is setted from optimizely we need to pass as(sessionParam)
// You need to use this format in optimizely sessionStorage.setItem('isRegisterV2Enabled',JSON.stringify({'isEnabled':'true','enabledCountry':'US'})
const isFeatureEnabledViaSessionStorage = (sessionParam) => {
    try{
      const {country} = getCountryAndLanguage();
      const isSessionEnabled = sessionStorage.getItem(sessionParam) ? JSON.parse(sessionStorage.getItem(sessionParam)) : '';
      let isCampaignEnabled = false;
      if(isSessionEnabled && isSessionEnabled?.isEnabled && isSessionEnabled?.enabledCountry){
        isCampaignEnabled = isSessionEnabled.isEnabled == 'true' && (isSessionEnabled.enabledCountry.indexOf(country?.toLowerCase()) != -1 || isSessionEnabled.enabledCountry.indexOf(country?.toUpperCase()) != -1 );
      }
      return isCampaignEnabled;
    } catch(error){
      return false;
    }
  }
// date format with Timestamp
const convertDateFormatTstamp = (inputDate) => {
    // Parse input date (MM/DD/YYYY)
    let [month, day, year] = inputDate.trim().split("/").map(Number);

    // Create a Date object (assuming UTC initially)
    let date = new Date(Date.UTC(year, month - 1, day, 8, 47, 51, 0)); // Adjust time as needed

    // Format to ISO 8601 with timezone offset
    return date.toISOString().replace("Z", "+05:30");
}

// date format to YYYY-MM-DD
const convertDateFormat = (dateStr) => {
    if (!dateStr) {
        return null;
    }
    const parts = dateStr.split('/');
    if (parts.length === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return null;
}
function parseApiDate(val) {
 if (!val) return null;
 
 if (/^\d{8}$/.test(val)) {
  const y = val.slice(0, 4);
  const m = val.slice(4, 6);
  const d = val.slice(6, 8);
  const dt = new Date(`${y}-${m}-${d}`);
  return isNaN(dt) ? null : dt;
 }
 
 const dt = new Date(val);
 return isNaN(dt) ? null : dt;
}

function convertDate(stringdate) {
    let cust_info = sessionStorage.getItem('mywuApp');
    let parsed_info = JSON.parse(cust_info);
    let  cntry_cd = parsed_info?.customer["address"]["countryCode"]
    let stringdate_format = stringdate.replace(/-/g, "/");
    let date_array = stringdate_format.split("/");
    if(cntry_cd == "US"){
        stringdate_format = `${ date_array[1]}/${ date_array[2]}/${ date_array[0]}`;
    }
    else{
        stringdate_format = `${ date_array[2]}/${ date_array[1]}/${ date_array[0]}`;
    }
    return stringdate_format;
}

function currentTimeStampNow(){
    const getCurrentTime = new Date();
    return getCurrentTime.toISOString()
}

function formatDate(date) {
    return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
}

function removeEmptyReqKey(obj) {
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
            delete obj[key];
          }
        }
      }
      return JSON.stringify(obj);
  }

function getLocalLanguage(lang) {
    return lang.substring(0,2)
}

const DEVICE_VERIFICATION_COOKIE = 'A4kgk7ndltp_o';

function setCookieOnCreateSessionResponse(response) {
    const cookieName = "setCreatesSessionResponse";
    const sessionObj = window.getR4Country()  ? {
        id: response?.sessionId,
        clientIp: response?.clientIp,
        encryptedSessionId: response?.encryptedSessionId,
        dataCenter: response?.dataCenter
    } : {
        id: response?.security?.session?.id,
        clientIp: response?.security?.client_ip
    };
    CookieService.setSessionCookie(cookieName, JSON.stringify(sessionObj));
    let requestHeader = response?.security?.requestHeader;
    if(requestHeader) {
        const deviceVerifyFlag = requestHeader?.filter(val => val?.key === DEVICE_VERIFICATION_COOKIE);
        if(deviceVerifyFlag?.length > 0){
            CookieService.setCookie(DEVICE_VERIFICATION_COOKIE, 'enabled', 10, '/');
        } else{
            CookieService.deleteCookie(DEVICE_VERIFICATION_COOKIE);
        }
    }
}

/**
 * Checks if the current URL is the production URL (https://www.westernunion.com/)
 * @returns {boolean}
 */
const isProdUrl = () => {
    return window.location.origin + '/' === prodUrl;
};

const WU_DIGITAL_SCV_COUNTRIES = ['US'];


const calcAmt = (bestFx, req, isStrikedValue) => {
    if (isStrikedValue && bestFx.strike_fx_rate) {
        return (bestFx.strike_fx_rate && req.sendAmount) && (bestFx.strike_fx_rate * req.sendAmount);
    } else {
        return (bestFx.fx_rate && req.sendAmount) && (bestFx.fx_rate * req.sendAmount);
    }
}

// Helper to get session and client IP from cookies
function getSessionAndClientIpFromCookies() {
    const cookieSession = CookieService.getParsedCookieValue('setCreatesSessionResponse');
    return {
        sessionId: cookieSession?.id,
        clientIp: cookieSession?.clientIp,
        encryptedSessionId : cookieSession?.encryptedSessionId,
        dataCenter: cookieSession?.dataCenter
    }
}
/**
 * Dispatch Custom event with data
 */
function customEventListnenerData(eventName, data={}) {
    const triggerCustomEvent = new CustomEvent(eventName,{
        detail:data
    });
    document.dispatchEvent(triggerCustomEvent);
}

function debounceGeneric(func, delay) {
    let timer;
    return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    }
}

function wuSessionApp() {
    let myWuData = null;

    try {
        myWuData = JSON.parse(window.sessionStorage.getItem('app'));
    } catch (e) {
        myWuData = null;
    }

    const accountNumber = myWuData?.sender?.myWuNumber || "";
    const loyaltyFlag = myWuData?.sender?.termsConditionFlag || "";
    const registrationStatus = myWuData?.sender?.registrationStatus || "";

    return { accountNumber, loyaltyFlag, registrationStatus };
}

const LIMITS_CACHE_KEY = 'getLimitsApiResponse';

const getLimitCacheData = (destinationIsoCode) => {
    const cached = sessionStorage.getItem(`${LIMITS_CACHE_KEY}-${destinationIsoCode}`);
    if (cached) {
        try {
            return JSON.parse(cached);
        } catch (e) {
            // If parsing fails, clear the cache and continue
            sessionStorage.removeItem(`${LIMITS_CACHE_KEY}-${destinationIsoCode}`);
        }
    }
}

// Function to format date in UTC with specific format
const formatUTCDate = (date = new Date()) => {
  const parts = new Intl.DateTimeFormat(`${pageData.language}-US`, {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'UTC',
    timeZoneName: 'short'
  }).formatToParts(date);

  const get = t => parts.find(p => p.type === t)?.value;

  return `${get('month')} ${get('day')}, ${get('year')} (${get('hour')}:${get('minute')} ${get('dayPeriod')} ${get('timeZoneName')})`;
}

const setNavSendMoneyParams = (queryParam) => {
    if(!queryParam) return
    const sendMoeyEls = document.querySelectorAll('nav a[href*="send-money/start"]')
    Array.from(sendMoeyEls).forEach((el) => {
        el.href = `${el?.href?.split("?")[0]}${queryParam}`
    })
}